export default "__VITE_ASSET__BXEBuOU1__"